import { connect } from 'react-redux';
import { ProductHistoryEvent } from '~/Api/Product/History';
import { pruneProductHistory, selectEventsByProductId, State as ProductHistoryState } from '~/ProductHistory';

import { fetch } from './actions';
import HistoryTable from './HistoryTable';

interface State {
	productHistory: ProductHistoryState;
}

interface Props {
	id: string;
	isFetching: boolean;
	events: ProductHistoryEvent[];
	hasNextPage: boolean;
}

function mapStateToProps({ productHistory }: State, { productId }: { productId: string }): Props {
	const history = selectEventsByProductId(productHistory, productId);

	return {
		id: productId,
		isFetching: Boolean(history?.isFetching),
		events: history?.events ?? [],
		hasNextPage: Boolean(history?.pagination?.hasNextPage()),
	};
}

const actions: {
	onFetch: typeof fetch;
	onPrune: typeof pruneProductHistory;
} = {
	onFetch: fetch,
	onPrune: pruneProductHistory,
};

export default connect(mapStateToProps, actions)(HistoryTable);
